import { render } from "./GalleryAdd.vue?vue&type=template&id=01c3f58f&scoped=true"
import script from "./GalleryAdd.vue?vue&type=script&lang=js"
export * from "./GalleryAdd.vue?vue&type=script&lang=js"

import "./GalleryAdd.vue?vue&type=style&index=0&id=01c3f58f&lang=css"
import "./GalleryAdd.vue?vue&type=style&index=1&id=01c3f58f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c3f58f"]])

export default __exports__